// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3s-2";
export var cell = "_3s-6";
export var cellContainer = "_3s-3";
export var disabled = "_3s-5";
export var featuredIconCellContainer = "_3s-7";
export var featuredIconTextContainer = "_3s-9";
export var featuredIconWrapper = "_3s-8";
export var hasRowsSelected = "_8d-1";
export var noBorder = "_3s-a";
export var overflowableText = "_3s-0";
export var overflowableTextContainer = "_3s-1";
export var row = "_3t-0";
export var rowCheckboxCell = "_3s-4";
export var selectableTable = "_8d-2";